<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

const route = useRoute()


const header_items = computed(() => [
  {
    label: t('general.home'),
    to: localePath('/'),
    exact: true,
    active: route.path.startsWith(localePath('/'))
  },
  {
    label: t('auth.login'),
    to: localePath('/login'),
    exact: true,
    active: route.path.startsWith(localePath('/login'))
  },
  {
    label: t('auth.sign_up'),
    to: localePath('/signup'),
    exact: true,
    active: route.path.startsWith(localePath('/signup'))
  },
]);

useHead({
  bodyAttrs: {
    class: 'dark:bg-gray-950'
  }
})

const title = 'ShiftGo'
const description = 'ShiftGo is shift management platform.'

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
})

</script>

<template>
  <div class="flex flex-col flex-grow">
    <UHeader title="ShiftGo">
      <template #title>
        <Logo class="h-6 w-auto" />
      </template>

      <template #center>
        <UHeaderLinks :links="header_items" />
      </template>

      <template #right>
        <LocaleSelector />
      </template>
    </UHeader>

    <div class="gradient" />

    <div class="flex flex-col justify-between items-center justify-center overlay">
      <slot />
    </div>

    <UFooter class="mt-auto">
      <template #left>
      </template>

      <template #center>
        <p class="text-(--ui-text-muted) text-sm mr-10">
          {{ $t('general.copyright') }} © {{ new Date().getFullYear() }}
        </p>
        <UButton icon="i-heroicons-cog" color="black" class="" v-on:click="$CC.showPreferences()">
          {{ $t('general.cookie_settings') }}
        </UButton>
      </template>
    </UFooter>
  </div>
</template>

<style scoped>
.gradient {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(50% 50% at 50% 50%, rgb(var(--color-primary-500) / 0.25) 0, #FFF 100%);
}

.dark {
  .gradient {
    background: radial-gradient(50% 50% at 50% 50%, rgb(var(--color-primary-400) / 0.1) 0, rgb(var(--color-gray-950)) 100%);
  }
}

.overlay {
  background-size: 100px 100px;
  background-image:
    linear-gradient(to right, rgb(var(--color-gray-200)) 0.5px, transparent 0.5px),
    linear-gradient(to bottom, rgb(var(--color-gray-200)) 0.5px, transparent 0.5px);
}

.dark {
  .overlay {
    background-image:
      linear-gradient(to right, rgb(var(--color-gray-900)) 0.5px, transparent 0.5px),
      linear-gradient(to bottom, rgb(var(--color-gray-900)) 0.5px, transparent 0.5px);
  }
}
</style>